import { activeOrgSelector } from 'redux/reducer/AuthenticationReducer';
import { axiosInstance } from 'utils/http';
import { liveCleanroom } from 'utils/urlConstants';
import { showAlert } from 'redux/actions/AlertActions';
import { useDispatch, useSelector } from 'react-redux';
import { useMutation, useQueryClient } from 'react-query';


export const useCreateWarehouse = (lcrId) => {
  const { ID: orgId } = useSelector(activeOrgSelector);
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  return useMutation(
    (payload) => axiosInstance.post(liveCleanroom(orgId)
      .createWarehouse(lcrId), payload),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['warehouseList', lcrId] });
        dispatch(showAlert({
          message: 'Warehouse created successfully',
          type: 'success',
        }));
      },
      onError: (error) => {
        dispatch(
          showAlert({
            message: error.response?.data?.message || 'Error creating warehouse',
            type: 'error',
          }),
        );
      },
    },
  );
};
